import { render, staticRenderFns } from "./SignatureForwardDoc.vue?vue&type=template&id=9f5f983c"
import script from "./SignatureForwardDoc.vue?vue&type=script&lang=js"
export * from "./SignatureForwardDoc.vue?vue&type=script&lang=js"
import style0 from "./SignatureForwardDoc.vue?vue&type=style&index=0&id=9f5f983c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports